import { D20 } from "./ComparativeMonthlySales/D20";
import { D21 } from "./ComparativeMonthlySalesDrugstoreChains/D21";
import { D08 } from "./ProductSalesGrowthPerformance/D08";
import { D22 } from "./ProductSalesbyChannelPESO/D22";
import { D25 } from "./ProductSalesByCustomerGroupPESO/D25";

export const DistrictComparativeSales = {
    "sections": [
      D20,
      D21,
      D08,
      D22,
      D25
    ]
  }